export default class Recorder {
    /**
     * Create recorder with stream
     * @param {Object.<{
     *  recordingPath: string,
     *  spitRecordingOnResolutionChange: boolean
     *  }>}  recordingParameters Parameters for the recording got from the application + plugin
     * @param {OpentokService} opentokService an OpentokService instance
     * @param {MediaStream} stream the MediaStream we want to record
     */
    constructor(recordingParameters, opentokService, stream) {
        this.recordingParameters = recordingParameters;
        this.opentokService = opentokService;
        this.recordings = [];
        this.currentRecording = null;
        this.stream = stream;
    }

    /**
     * Start recording
     * @return {Promise}
     */
    start() {
        if (!(this.opentokService && this.stream)) return Promise.reject('Recorder has been disposed');
        if (this.currentRecording && this.currentRecording.state === 'recording') {
            return Promise.reject('The recorder is already started');
        }
        
        let gumStream = this.stream.getGUMStream();

        var streamToPass;
        if (this.opentokService.config.videoResolution !== undefined) {
            streamToPass = this.stream;
        }
        
        return this.opentokService.startSession(streamToPass)
            .then(() => this.opentokService.startRecording(this.recordingParameters)
                .then((response) => {
                    this.currentRecording = {
                        state: 'recording',
                        id: response.id,
                    };
                    this.recordings.push(this.currentRecording);
                    return this.currentRecording.id;
                }), error => Promise.reject(error),
            error => Promise.reject(error));
    }

    /**
     * Stops recording
     * @return {*}
     */
    stop() {
        if (!(this.opentokService && this.stream)) return Promise.reject('Recorder has been disposed');
        if (!this.currentRecording || this.currentRecording.state !== 'recording') {
            return Promise.reject('The recorder is not recording');
        }
        return this.opentokService.stopRecording(this.currentRecording.id, this.recordingParameters)
            .then((response) => {
                this.currentRecording.state = 'done';
                return response;
            }, (error) => {
                this.currentRecording.state = 'error';
                throw error;
            });
    }

    /**
     * Disposes the recorder
     * @return {*}
     */
    dispose() {
        if (this.currentRecording && this.currentRecording.state === 'recording') {
            return this.stop().then(() => this.dispose()); // stop if disposed called while recording
        }
        this.opentokService.stopSession();
        this.opentokService = null;
        this.stream = null;
        return Promise.resolve();
    }

    /**
     * Get information about recordings
     * @return {*}
     */
    getRecordings() {
        return Promise.resolve(this.recordings);
    }
}
